/* Programme A/B (11/10/2026) — comportements des versions qui touchent au panier.
 * Chargé seulement quand un test du programme est actif (layout/theme.liquid). Les versions sont lues sur <html> :
 * data-v-offre, data-v-tiroir, data-v-upsell, data-v-email (posés par l'amorce du suivi, cro-tracker-head).
 * Données du thème : window.RS_AB (ids des cadeaux, handles des shampoings), écrit par layout/theme.liquid.
 *
 *  - offre « cadeaux » : 1 filet offert par lot de 2 ou de 3, 1 brosse offerte en plus par lot de 3. Les cadeaux (produits à 0 €)
 *    suivent les lots du panier après chaque modification ; sans la version « cadeaux », ils sont retirés (jamais de cadeau
 *    gratuit ajouté par une URL).
 *  - offre « bundle » : les soins cochés sous les offres partent au panier juste après le shampoing.
 * Après une correction, le tiroir est re-rendu par le thème (ajaxCart.load), comme pour les lots.
 */
(function () {
  var H = document.documentElement, AB = window.RS_AB || {};
  function v(z) { return H.getAttribute('data-v-' + z) || ''; }
  var SHAMP = AB.shampoings || [];   // socle 1.1.0 : produits du programme posés par boutique-specifique (ab-donnees)
  var CAD = AB.cadeaux || {};
  var interne = false, file = Promise.resolve();
  function enFile(fn) { file = file.then(fn).catch(function () {}); return file; }
  function json(url, corps) {
    return fetch(url, corps ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) }
      : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function rafraichir() {
    if (/\/cart(\/|$)/.test(location.pathname)) { location.reload(); return; }
    json(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=side-cart' : '/?sections=side-cart').then(function (sections) {
      if (window.ajaxCart && typeof ajaxCart.load === 'function') ajaxCart.load({ sections: sections }, false);
    }).catch(function () {});
  }
  function taille(item) { var m = /-(\d+)$/.exec(item.sku || ''); return m ? +m[1] : 1; }

  /* ── Cadeaux ── */
  function cadeaux(c) {
    if (!CAD.filet || !CAD.brosse) return null;
    var lot2 = 0, lot3 = 0, a = {}; a[CAD.filet] = 0; a[CAD.brosse] = 0;
    (c.items || []).forEach(function (it) {
      if (SHAMP.indexOf(it.handle) !== -1) { var t = taille(it); if (t === 2) lot2 += it.quantity; else if (t === 3) lot3 += it.quantity; }
      if (it.variant_id in a) a[it.variant_id] += it.quantity;
    });
    var on = v('offre') === 'cadeaux', veut = {}; veut[CAD.filet] = on ? lot2 + lot3 : 0; veut[CAD.brosse] = on ? lot3 : 0;
    var u = {}, n = 0;
    for (var id in veut) if (veut[id] !== a[id]) { u[id] = veut[id]; n++; }
    return n ? u : null;
  }

  function corriger() {
    return json('/cart.js').then(function (c) {
      var u = cadeaux(c);
      if (!u) return false;
      interne = true;
      var ajout = [], maj = {};
      for (var id in u) {
        var deja = (c.items || []).some(function (it) { return String(it.variant_id) === String(id); });
        if (deja || !u[id]) maj[id] = u[id]; else ajout.push({ id: +id, quantity: u[id] });
      }
      var p = Promise.resolve();
      if (Object.keys(maj).length) p = p.then(function () { return json('/cart/update.js', { updates: maj }); });
      if (ajout.length) p = p.then(function () { return json('/cart/add.js', { items: ajout }); });
      return p.then(function () { interne = false; return true; }, function () { interne = false; return false; });
    }).catch(function () { return false; });
  }
  function corrigerPuisRafraichir() { return enFile(function () { return corriger().then(function (ch) { if (ch) rafraichir(); return ch; }); }); }

  /* ── Bundle : soins cochés, ajoutés après le shampoing ── */
  var bundleEnAttente = null;
  function noterBundle() {
    if (v('offre') !== 'bundle') return;
    var ids = [].slice.call(document.querySelectorAll('[data-abt-bundle] input:checked')).map(function (x) { return +x.value; }).filter(Boolean);
    bundleEnAttente = ids.length ? ids : null;
  }
  // Le thème ajoute au panier en AJAX : on note les soins cochés au clic sur un bouton d'ajout (fiche ou sticky) et à l'envoi.
  document.addEventListener('submit', function (e) { if (e.target && e.target.id === 'rp-form') noterBundle(); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#rp-form [name="add"], [data-rp-sticky-ajouter]')) noterBundle();
  }, true);
  function ajouterBundle() {
    if (!bundleEnAttente) return Promise.resolve(false);
    var ids = bundleEnAttente; bundleEnAttente = null; interne = true;
    return json('/cart/add.js', { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      .then(function () { interne = false; return true; }, function () { interne = false; return false; });
  }

  /* ── Après chaque modification du panier, quelle qu'en soit l'origine ── */
  var ROUTES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  function concerne(url) { if (interne) return false; url = String(url); for (var i = 0; i < ROUTES.length; i++) if (url.indexOf(ROUTES[i]) !== -1) return true; return false; }
  // Les écritures du panier ne doivent jamais se croiser (Shopify garde la dernière) : le bundle part seulement après la
  // réponse de l'ajout du shampoing (/cart/add), tout passe par la même file d'attente.
  function apres(url) {
    var ajout = String(url).indexOf('/cart/add') !== -1;
    enFile(function () { return (ajout ? ajouterBundle() : Promise.resolve(false)).then(function (b) { return corriger().then(function (c) { if (b || c) rafraichir(); }); }); });
  }
  var _fetch = window.fetch;
  if (_fetch) window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '', vise = concerne(url), p = _fetch.apply(this, arguments);
    if (vise) p.then(function (r) { if (r && r.ok) setTimeout(function () { apres(url); }, 60); }).catch(function () {});
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (concerne(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(function () { apres(url); }, 60); });
    return _open.apply(this, arguments);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', corrigerPuisRafraichir); else corrigerPuisRafraichir();

  window.rsAB = { corriger: corrigerPuisRafraichir, rafraichir: rafraichir, json: json, v: v };
})();

/* ── Haut de fiche C (haut-fiche-3) : diagnostic en 3 taps ── */
(function () {
  function init() {
    var d = document.querySelector('[data-abt-diag]');
    if (!d) return;
    var rep = {}, pas = d.querySelectorAll('.abt-diag-pas i');
    function montrer(n) {
      [].forEach.call(d.querySelectorAll('[data-q]'), function (q) { q.hidden = +q.getAttribute('data-q') !== n; });
      [].forEach.call(pas, function (p, i) { p.className = i < Math.min(n, 3) ? 'on' : ''; });
    }
    function offre() {
      // 3e offre de la version du sélecteur affichée (lot de 3, ou 2+2 en version D) : libellé et prix lus sur la page
      var o = document.querySelector('#rp-produit .rp-offres .rp-offre[data-i="2"]');
      if (!o) return '';
      var vis = function (sel) { return [].filter.call(o.querySelectorAll(sel), function (x) { return x.offsetParent !== null; })[0]; };
      var l = vis('.rp-ligne'), px = vis('[data-rp-prix]');
      return (l ? l.querySelector('b').textContent.trim() : '') + (px ? ' · ' + px.textContent.trim() : '');
    }
    d.addEventListener('click', function (e) {
      var b = e.target.closest('.abt-diag-ch button');
      if (b) {
        var q = b.closest('[data-q]'), n = +q.getAttribute('data-q');
        [].forEach.call(q.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        rep[n] = b.getAttribute('data-v');
        if (n < 3) { setTimeout(function () { montrer(n + 1); }, 180); return; }
        // Réponses gardées sur le panier, donc sur la commande (attribut cro_diag, ex. « casse,fins,semaine »).
        fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { cro_diag: [rep[1], rep[2], rep[3]].join(',') } }) }).catch(function () {});
        [].forEach.call(d.querySelectorAll('[data-r]'), function (li) { li.hidden = [rep[1], rep[2], rep[3]].indexOf(li.getAttribute('data-r')) === -1; });
        var t = d.querySelector('[data-abt-diag-offre]'); if (t) t.textContent = offre();
        setTimeout(function () { montrer(4); }, 180);
        return;
      }
      if (e.target.closest('[data-abt-diag-go]')) {
        var o = document.querySelector('#rp-produit .rp-offres .rp-offre[data-i="2"]');
        if (o) o.click();
        var btn = document.querySelector('#rp-form [name="add"]');
        if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (e.target.closest('[data-abt-diag-re]')) { rep = {}; [].forEach.call(d.querySelectorAll('[aria-pressed]'), function (x) { x.removeAttribute('aria-pressed'); }); montrer(1); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ── Sélecteur E : « Le duo de soins » coche le spray et l'huile ; les deux cochés = duo coché ── */
(function () {
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('[data-abt-bundle]');
    if (!f) return;
    var duo = f.querySelector('[data-abt-duo]'), seuls = [].slice.call(f.querySelectorAll('input[type="checkbox"]:not([data-abt-duo])'));
    if (e.target === duo) seuls.forEach(function (x) { x.checked = duo.checked; });
    else if (duo) duo.checked = seuls.every(function (x) { return x.checked; });
  });
})();
